import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { VDRFileSourceType } from '../models/vdr-file-source-type.enum';

export interface CopyVDRFileRequest {
    engagementId: number;
    fileSourceType: VDRFileSourceType;
    vdrFileId?: number;
    sourceAnswerFileId?: number;
    sourceQuestionId?: number;
    sourceDataFormId?: number;
    sourceDataTableCellFileId?: number;
    sourceDataTableId?: number;
    destinationFolderPath: string;
}

export const CopyVDRFile = createAsyncThunk(
    'dataRoom/copyFile',
    async (
        {
            engagementId,
            fileSourceType,
            vdrFileId,
            sourceAnswerFileId,
            sourceQuestionId,
            sourceDataFormId,
            sourceDataTableCellFileId,
            sourceDataTableId,
            destinationFolderPath,
        }: CopyVDRFileRequest,
        { getState }: any
    ) => {
        const axios = getState().core.axios;

        try {
            const response = await axios.post(
                `api/VirtualDataRoomDocument/${engagementId}/file/copy`,
                {
                    fileSourceType,
                    vdrFileId,
                    sourceAnswerFileId,
                    sourceQuestionId,
                    sourceDataFormId,
                    sourceDataTableCellFileId,
                    sourceDataTableId,
                    destinationFolderPath,
                }
            );

            if (response.status !== 200) {
                createNotification(
                    'Could not copy file at the moment.',
                    'error'
                );
                throw new Error('Failed to copy file');
            }

            return response.data;
        } catch (error) {
            createNotification(
                'An error occurred while copying file.',
                'error'
            );
            throw error;
        }
    }
);
